<template>
  <div :class="['input-tel', {'md-disabled': disabled}]">
    <div class="input-tel-flag-list">
      <label>{{label}}</label>
      <!--<div v-bind:class="`input-tel-flag ${isoClass}`" @click="openSelect"></div>-->
      <div v-bind:class="`input-tel-flag`" @click="openSelect">
        {{dialCode}}
      </div>
      <md-menu :md-active.sync="open">
        <md-menu-content>
          <md-menu-item @click="choose(item['iso2'])" v-for="item in allCountries" :key="item['iso2']">
            <span class="country-name">{{ item.name }}</span>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>
    <md-field class="input-tel-number">
      <md-input :id="name" :name="name" v-model="phoneNumber" required :disabled="disabled" @keypress="onlyNumber"></md-input>
    </md-field>
  </div>
</template>

<script>
import { formatNumber, AsYouType, parseNumber } from 'libphonenumber-js';
import EventBus from '../../eventBus';
import allCountries from './all-countries.js';
export default {
  data() {
    return {
      allCountries,
      iso: '',
      phoneNumber: '',
      formattedNumberInternational: '',
      open: false,
    };
  },
  props: {
    name: String,
    disabled: Boolean,
    label: String,
    defaultIso: String,
    defaultValue: String,
  },
  mounted() {
    this.$nextTick(function() {
      if (this.defaultIso) {
        this.iso = this.defaultIso;
        if (!this.phoneNumber) {
          this.$nextTick(function() {
            this.phoneNumber = this.defaultValue;
          });
        }
      }
    });
  },
  watch: {
    phoneNumber(value) {
      //this.phoneNumber = this.format(value);
      this.format(value);
    },
    defaultIso(value) {
      this.choose(value);
    },
  },
  computed: {
    isoClass() {
      return this.iso.toLowerCase();
    },
    dialCode() {
      if (this.iso) {
        return '+'+this.allCountries.find(ele => ele.iso2.toUpperCase() === this.iso).dialCode
      }
      return '';
    }
  },
  methods: {
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 43) {
          $event.preventDefault();
      }
    },
    choose(iso) {
      this.iso = iso;
      //this.phoneNumber = this.format(new AsYouType(iso).input(this.phoneNumber));
      this.format(new AsYouType(iso).input(this.phoneNumber));
    },
    openSelect() {
      this.open = !this.open;
    },
    format(value) {
      let valueToFormat = value;
      if (this.phoneNumber[0] === '0') {
        valueToFormat = valueToFormat.substr(1);
      }
      if (this.phoneNumber && this.phoneNumber[0] === '+') {
        const formatter = parseNumber(this.phoneNumber);
        const findCountry = this.allCountries.find(ele => ele.iso2.toUpperCase() === formatter.country) || this.iso;// eslint-disable-line
        this.iso = (findCountry.iso2) ? findCountry.iso2 : this.iso;// eslint-disable-line
      }
      this.formattedNumberInternational = formatNumber(valueToFormat, this.iso, 'International');
      this.$emit('update:phone', {tel: this.phoneNumber, intl: this.formattedNumberInternational });
      return new AsYouType(this.iso).input(value);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/TelInput/TelInput.vue